import { forwardRef } from "react"
import { SelectX } from "web/components"

import { useSearch } from "web/hooks/data"

import ControlContainer from "./ControlContainer"

const UserLookup = forwardRef((props, ref) => {
  const {
    name,
    value,
    kind,
    error,
    touched,
    multiple_values,
    onChange,
    onFocus,
    autoFocus,
    disabled = false,
  } = props

  const search = useSearch("user")

  async function decodeValue(rawValue) {
    return { value: rawValue.value, label: rawValue.label, kind }
  }

  async function handleSelectXChange(value) {
    if (value === null) {
      onChange(null)
    } else if (multiple_values) {
      const decodedValue = []

      for (const valueEl of value) {
        decodedValue.push(await decodeValue(valueEl))
      }

      onChange(decodedValue)
    } else {
      onChange(await decodeValue(value))
    }
  }

  return (
    <ControlContainer {...props} errorCondition={error && touched}>
      <SelectX
        ref={ref}
        name={name}
        value={value}
        onChange={handleSelectXChange}
        onFocus={onFocus}
        validValues={search}
        options={{
          multipleValues: multiple_values || false,
          clearOnFocus: true,
          inputClassName: "form-control lookup",
          autoFocus,
          placeholder: "Search users...",
        }}
        disabled={disabled}
      />
    </ControlContainer>
  )
})

export default UserLookup
